import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://xaintro-backend.onrender.com';

// Create axios instance
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const promotionService = {
  // Get all promotions
  getPromotions: async (params = {}) => {
    const response = await api.get('/promotions', { params });
    return response;
  },

  // Get active promotions
  getActivePromotions: async () => {
    const response = await api.get('/promotions', {
      params: { active: true }
    });
    return response;
  },

  // Get promotions by type
  getPromotionsByType: async (type) => {
    const response = await api.get(`/promotions/type/${type}`);
    return response;
  },

  // Get single promotion
  getPromotion: async (id) => {
    const response = await api.get(`/promotions/${id}`);
    return response;
  },

  // Create promotion
  createPromotion: async (promotionData) => {
    const isFormData = promotionData instanceof FormData;
    const config = isFormData ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};
    const response = await api.post('/promotions', promotionData, config);
    return response;
  },

  // Update promotion
  updatePromotion: async (id, promotionData) => {
    const isFormData = promotionData instanceof FormData;
    const config = isFormData ? {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    } : {};
    const response = await api.put(`/promotions/${id}`, promotionData, config);
    return response;
  },

  // Delete promotion
  deletePromotion: async (id) => {
    const response = await api.delete(`/promotions/${id}`);
    return response;
  },

  // Upload promotion image
  uploadPromotionImage: async (formData) => {
    const response = await api.post('/upload/promotions', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response;
  },
};

export default promotionService;
